export default [
  {
    title: 'قراردادها',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'لیست قراردادها',
        icon: 'ListIcon',
        route: 'Contract_List',
        permission: 'contracts.index',
      },
      {
        title: 'ثبت قرارداد',
        icon: 'PlusIcon',
        route: 'Contract_Create',
        permission: 'contracts.store',
      },
    ],
  },
]